module.exports = __webpack_public_path__ + "static/media/Finansii-Mobile-al.0f817d04.jpg";